import styles from './RadioLabel.module.scss'

const RadioLabel = ({ name, labelText, children, checked, onChange }) => (
  <label className={checked ? styles.radioLabelChecked : styles.radioLabel} key={name}>
    <input
      type="radio"
      className={styles.radioInput}
      name={name}
      onChange={onChange}
      checked={checked}
    />
    <div className={styles.radioLabelInner}>{labelText}</div>
    {children}
  </label>
)

export default RadioLabel
